import React, { useEffect, useRef } from "react";
import Story1 from "./story1.jpg";
import Story2 from "./story2.jpg";
import Story3 from "./story3.jpg";
import styles from "./style/Storycontent.module.css";

const Content = () => {
  const section1Ref = useRef(null);
  const section2Ref = useRef(null);
  const section3Ref = useRef(null);
  const section4Ref = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const section1 = section1Ref.current;
      const section1Top = section1.getBoundingClientRect().top;
      const section2 = section2Ref.current;
      const section2Top = section2.getBoundingClientRect().top;
      const section3 = section3Ref.current;
      const section3Top = section3.getBoundingClientRect().top;
      const section4 = section4Ref.current;
      const section4Top = section4.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (section1Top <= windowHeight / 2) {
        section1.scrollIntoView({ behavior: "smooth" });
      }
      if (section2Top <= windowHeight / 2) {
        section2.scrollIntoView({ behavior: "smooth" });
      }
      if (section3Top <= windowHeight / 2) {
        section3.scrollIntoView({ behavior: "smooth" });
      }
      if (section4Top <= windowHeight / 2) {
        section4.scrollIntoView({ behavior: "smooth" });
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.storyCountainer}>
      <div style={{ height: "20vh" }}></div>
      <div ref={section1Ref} className={styles.storytext}>
          The first time I encountered rhythm games was in high school. One day,
          while hanging out with friends, one of them showed me a bunch of
          rhythm games on his iPad. Watching his fingers dance across the
          screen, hitting perfect notes one after another, I couldn't help but
          be drawn in by the wonderful music and visual effects. That moment
          marked the beginning of my enduring love affair with rhythm games.
        <img class={styles.storyimg} src={Story1} />
      </div>
      <div style={{ height: "100%" }}></div>
      <div ref={section2Ref} className={styles.storytext}>
        <img class={styles.storyimg} src={Story2} />
        <div>
          When I first entered university, rhythm games became almost like a
          lifeline for me. I found immense joy in heading to the arcade to play
          Maimai every Friday, and during breaks between classes, I would rotate
          through various games, striving to achieve high scores. Rhythm games
          provided me with a profound sense of accomplishment, reinforcing the
          belief that hard work always pays off.
        </div>
      </div>
      <div style={{ height: "200%" }}></div>
      <div ref={section3Ref} className={styles.storytext}>
        <div>
          At the same time, the unique music styles and mesmerizing art
          aesthetics of rhythm games captivated me deeply, influencing my sense
          of aesthetics. Although music is the core of rhythm games, and the
          music itself is often outstanding, each game also has its own story
          and worldview, which further enticed me to explore.
        </div>
        <img class={styles.storyimg} src={Story3} />
      </div>
      <div style={{ height: "300%" }}></div>
      <div ref={section4Ref} className={styles.storytext}>
        <div>
          As a member of a niche gaming community, I'm eager to share the unique
          charm of rhythm games with more people. Hence, the idea of creating
          this website was born. While it may not be the most comprehensive
          resource for rhythm games, I hope it will spark interest in others,
          and for me, that's enough.
        </div>
      </div>
    </div>
  );
};

export default Content;
